package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LockW500Rounded: ImageVector
    get() {
        if (_lockW500Rounded != null) {
            return _lockW500Rounded!!
        }
        _lockW500Rounded = Builder(name = "LockW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(242.87f, 887.41f)
                quadToRelative(-37.54f, 0.0f, -64.27f, -26.73f)
                quadToRelative(-26.73f, -26.73f, -26.73f, -64.27f)
                verticalLineToRelative(-394.26f)
                quadToRelative(0.0f, -37.54f, 26.73f, -64.27f)
                quadToRelative(26.73f, -26.73f, 64.27f, -26.73f)
                horizontalLineToRelative(33.54f)
                verticalLineToRelative(-73.06f)
                quadToRelative(0.0f, -84.92f, 59.46f, -144.61f)
                quadToRelative(59.46f, -59.7f, 144.13f, -59.7f)
                quadToRelative(84.67f, 0.0f, 144.13f, 59.7f)
                quadToRelative(59.46f, 59.69f, 59.46f, 144.61f)
                verticalLineToRelative(73.06f)
                horizontalLineToRelative(33.54f)
                quadToRelative(37.54f, 0.0f, 64.27f, 26.73f)
                quadToRelative(26.73f, 26.73f, 26.73f, 64.27f)
                verticalLineToRelative(394.26f)
                quadToRelative(0.0f, 37.54f, -26.73f, 64.27f)
                quadToRelative(-26.73f, 26.73f, -64.27f, 26.73f)
                lineTo(242.87f, 887.41f)
                close()
                moveTo(242.87f, 796.41f)
                horizontalLineToRelative(474.26f)
                verticalLineToRelative(-394.26f)
                lineTo(242.87f, 402.15f)
                verticalLineToRelative(394.26f)
                close()
                moveTo(536.5f, 655.78f)
                quadToRelative(23.5f, -23.5f, 23.5f, -56.5f)
                reflectiveQuadToRelative(-23.5f, -56.5f)
                quadToRelative(-23.5f, -23.5f, -56.5f, -23.5f)
                reflectiveQuadToRelative(-56.5f, 23.5f)
                quadToRelative(-23.5f, 23.5f, -23.5f, 56.5f)
                reflectiveQuadToRelative(23.5f, 56.5f)
                quadToRelative(23.5f, 23.5f, 56.5f, 23.5f)
                reflectiveQuadToRelative(56.5f, -23.5f)
                close()
                moveTo(367.41f, 311.15f)
                horizontalLineToRelative(225.18f)
                verticalLineToRelative(-73.06f)
                quadToRelative(0.0f, -47.21f, -32.73f, -80.26f)
                quadToRelative(-32.73f, -33.05f, -79.86f, -33.05f)
                reflectiveQuadToRelative(-79.86f, 33.05f)
                quadToRelative(-32.73f, 33.05f, -32.73f, 80.26f)
                verticalLineToRelative(73.06f)
                close()
                moveTo(242.87f, 796.41f)
                verticalLineToRelative(-394.26f)
                verticalLineToRelative(394.26f)
                close()
            }
        }
        .build()
        return _lockW500Rounded!!
    }

private var _lockW500Rounded: ImageVector? = null
